import React,{ useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import html2canvas from 'html2canvas';
import { getBookingLocationDetail, getUserInTimerange, cancelBooking } from '../Network/Booking'
import dayjs from 'dayjs'
import QRCode from 'react-qr-code'
import "./CheckInQRCode.css"

const formatTime = (time) => {
    const currentDate = dayjs().format("YYYY-MM-DD")
    const datewithTime = `${currentDate} ${time}`
    const datewithTimeFormatted = dayjs(datewithTime).format("H:mm")
    return datewithTimeFormatted
}

function CheckInQRCode() {
    const { location_id } = useParams()
    const [selectDate, setSelectDate] = useState(new Date())
    const [formatQRcode, setformatQRcode]  = useState(1)

    const fetchData = (startDate) => {
        getBookingLocationDetail(location_id, startDate,
            (data)=>{
                console.log(data.locationCode)
                setformatQRcode('lifelink://booking/'+data.locationCode);
            },
            (error)=>{
               
            })
    }

    useEffect(()=>{
        fetchData(selectDate)
    },[])

    return (
        <div className='doc-container'>
            <div className="a4-container" style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'50px'}}>
                <QRCode value={formatQRcode} />
                <div style={{marginTop:'20px'}}>{formatQRcode}</div>
            </div>
        </div>
    )
}

export default CheckInQRCode
